import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { FacetHit } from '@/composables/useDynamicProductListing'
import { getContext } from '@/composables/useDynamicProductListing';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetButtonCheckbox',
  props: {
    facet: null
  },
  setup(__props: any) {

const props = __props as {
  facet: FacetHit
}

const { activeFacets, openFacetDrawer } = getContext();



const open = () => {
  if (isDisabled.value) { return; }
  openFacetDrawer(props.facet, false);
};

const isActive = computed(() => activeFacets.find(r => r.id === props.facet.id));
const isDisabled = computed(() => props.facet.values.every((value) => value.count < 1));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (open()), ["prevent"])),
    class: _normalizeClass(["facet-button-checkbox", [{'facet-button-checkbox--active': _unref(isActive)},
    {'facet-button-checkbox--disabled': _unref(isDisabled)}]])
  }, _toDisplayString(__props.facet.name), 3))
}
}

})